var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.2443C7.26971 11.2443 7.48838 11.0256 7.48838 10.7559V6.84891C7.48838 6.5792 7.26971 6.36053 7 6.36053C6.73029 6.36053 6.51163 6.5792 6.51163 6.84891V10.7559C6.51163 11.0256 6.73029 11.2443 7 11.2443Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 4.24438C7.35965 4.24438 7.65118 4.53592 7.65118 4.89555C7.65118 5.25517 7.35965 5.54671 7.00001 5.54671C6.64038 5.54671 6.34885 5.25517 6.34885 4.89555C6.34885 4.53592 6.64038 4.24438 7.00001 4.24438Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5ZM7 1.47674C3.67345 1.47674 0.976744 4.17345 0.976744 7.5C0.976744 10.8265 3.67345 13.5233 7 13.5233C10.3265 13.5233 13.0233 10.8265 13.0233 7.5C13.0233 4.17345 10.3265 1.47674 7 1.47674Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/iIcon.6137b2e3a737b285607bf3055ee20b40.svg";
export { ForwardRef as ReactComponent };